import React from 'react';

class PrevArrow extends React.Component {
  render() {
    const {size, className, style, onClick} = this.props;

    return (
        <img
            className={className}
            style={{...style, display: 'block', width: size, height: size}}
            onClick={onClick}
            src={'https://copy-medcampus.s3.ap-south-1.amazonaws.com/wp-content/uploads/2019/05/09190646/iconfinder_arrow-left-01_186410.png'}
            alt={'Prev arrow'}
        />
    );
  }
}

export default PrevArrow;
